import Moment from 'moment'
window.Moment = Moment

import Pikaday from 'pikaday'
window.Pikaday = Pikaday

let reportForm = {
    $body: $('#js-body'),
    $dateInput: $('#js-dateInput'),
    $datePicker: $('#js-datePicker'),
    $direction: $('#js-direction'),
    $directionChanging: $('#js-directionChanging'),
    $time: $('#js-time'),
    $types: $('.js-reportType'),
    classNameDirection: 'js-direction',
    classNameDirectionInput: 'js-directionInput',
    classNameDirectionIsActive: 'is-active',
    classNameDirectionLabel: 'js-directionLabel',

    init() {
        this.initDate()
        this.initDirection()
        this.initTime()
    },

    initDate: function () {
        let currentYear = new Date().getFullYear()

        let picker = new Pikaday({
            field: this.$datePicker.get(0),
            i18n: window.hasOwnProperty('i18n') ? window.i18n : {},
            firstDay: 1,
            format: 'DD / MM / YYYY',
            maxDate: new Date(),
            onSelect: (date) => {
                this.$dateInput.val(picker.getMoment().format('YYYY-MM-DD'))
            },
            yearRange: [currentYear - 100, currentYear],
        })

        picker.setDate(this.$datePicker.attr('data-default'))
    },

    initDirection() {
        $(`.${this.classNameDirection}`).each((i, el) => {
            let $el
            let $input
            let $label
            
            $el = $(el)
            $input = $(`.${this.classNameDirectionInput}`, $el)
            $label = $(`.${this.classNameDirectionLabel}`, $el)

            $('path[data-direction-id]', $el).on({
                click: (e) => {
                    if ($(e.target).hasClass(this.classNameDirectionIsActive)) {
                        // Cancel direction
                        $('path[data-direction-id]', $el).removeClass(this.classNameDirectionIsActive)
                        $input.val('')
                    } else {
                        // Set direction
                        $('path[data-direction-id]', $el).removeClass(this.classNameDirectionIsActive)
                        $(e.target).addClass(this.classNameDirectionIsActive)
                        $input.val($(e.target).attr('data-direction-id'))
                        this.$directionChanging.prop('checked', false)
                    }
                },
                mouseover: (e) => {
                    $label.text($(e.target).attr('data-direction-name'))
                },
                mouseout: (e) => {
                    if ($(`.${this.classNameDirectionIsActive}`, $el).length) {
                        $label.text($(`.${this.classNameDirectionIsActive}`, $el).attr('data-direction-name'))
                    } else {
                        $label.text($el.attr('data-direction-none'))
                    }
                }
            })
        })

        this.$directionChanging.on('click', (e) => {
            if ($(e.target).is(':checked')) {
                this.$direction.find('path[data-direction-id]').removeClass('is-active')
                $(`.${this.classNameDirectionInput}`, this.$direction).val('')
            }

            $(`.${this.classNameDirectionLabel}`, this.$direction).text(this.$direction.attr('data-direction-none'))
        })
    },

    initTime: function () {
        this.$time.find('input').on({
            blur: (e) => this.$time.removeClass('is-focus'),
            focus: (e) => this.$time.addClass('is-focus')
        })
    }
}

export default reportForm